import { render, staticRenderFns } from "./IdentifierDisplayPreview.vue?vue&type=template&id=20813748"
import script from "./IdentifierDisplayPreview.vue?vue&type=script&lang=js"
export * from "./IdentifierDisplayPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports